<template>
    <rkm-form>
        <rkm-row>
            <rkm-col>
                <rkm-row>
                    <rkm-col cols="3">
                        <div>
                            <rkm-form-checkbox
                                v-model="data.model.gestacao.gestante"
                                :label="false"
                            >
                                Gestante
                            </rkm-form-checkbox>
                        </div>
                    </rkm-col>

                    <template v-if="data.model.gestacao.gestante">
                        <rkm-col cols="9">
                            <rkm-form-date-picker
                                :min-date="data.model.gestacao.dumMinDate"
                                :max-date="dumMaxDate"
                                label="DUM"
                                right
                                v-model="data.model.gestacao.dum"
                            />
                        </rkm-col>
                    </template>
                </rkm-row>

                <template v-if="data.model.gestacao.gestante">
                    <rkm-row>
                        <rkm-col cols="8">
                            <rkm-form-group
                                label-for="Idade gestacional"
                                label="Idade gestacional"
                                class="mb-0"
                            >
                                <rkm-row>
                                    <rkm-col cols="6">
                                        <rkm-form-input
                                            append="Semanas"
                                            disabled
                                            v-model="data.model.gestacao.idadeGestacional.semanas"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="6">
                                        <rkm-form-input
                                            append="Dias"
                                            disabled
                                            v-model="data.model.gestacao.idadeGestacional.dias"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-form-group>
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                disabled
                                label="DPP"
                                v-model="data.model.gestacao.dpp"
                            />
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins
import { repository, data, error } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        dumMaxDate() {

            return this.data.model.gestacao.dumMaxDate || this.data.form.dataAtual
        }
    },
    data: () => ({
        repositories: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
    },
    mixins: [repository, data, error],
    mounted() {
        this.repositories.geral = this.getConectaSusRepository('geral')
    },
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'data.model.gestacao.gestante': function (value) {
            if(value === false) {
                this.data.model.gestacao.dum = null
                this.data.model.gestacao.idadeGestacional.semanas = null
                this.data.model.gestacao.idadeGestacional.dias = null
                this.data.model.gestacao.dpp = null

            }
        },
        'data.model.gestacao.dum': function (value) {

            if (!(value instanceof Date)) {
                return false
            }

            const item = {...this.data.model.gestacao}
            this.formateDates(item, ['dum'])
            const dum = item.dum.split('-')

            this.setLoading()

            this.repositories.geral.calcularDPP({
                dia: dum[2],
                mes: dum[1],
                ano: dum[0],
            })
                .then(response => Object.assign(this.data.model.gestacao, response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    }
}
</script>